import { mapCompanyType, useFindCompanySuspense } from '@api';
import { NavigateBackButton } from '@common';
import { Group } from '@mantine/core';
import { Route } from 'src/routes/_rootLayout/companies/$id';

export const CompanyDetailsHeader: React.FC = () => {
  const { id } = Route.useParams();
  const { data: company } = useFindCompanySuspense(id, {
    query: { select: (data) => mapCompanyType(data.data) },
  });

  return (
    <Group gap="xs">
      <NavigateBackButton to="/companies" />
      {company.name}
    </Group>
  );
};
